import 'choerodon-ui/lib/progress/style';
